const hoverDevice = window.matchMedia('(hover: hover)').matches;

if (hoverDevice) {
  document.querySelectorAll('.menu-sidebar-tabs__tab').forEach((tab) => {
    tab.addEventListener('mouseenter', () => {
      const tabsComponent = tab.closest('tabs-component');
      if (!tabsComponent || typeof tabsComponent.setActiveTab !== 'function') return;

      const index = Number(tab.dataset.index);
      if (!Number.isNaN(index)) {
        tabsComponent.setActiveTab(index);
      }
    });
  });
}

// Tabs are links to their collection. The theme's tabs-component cancels tab clicks to switch panels,
// so open the link here instead: always on hover devices (hover already switched the panel), and on
// touch devices once the tab is already selected (first tap shows its products, second tap opens it).
document.addEventListener(
  'click',
  (event) => {
    const tab = event.target.closest('.menu-sidebar-tabs__tab[href]');
    if (!tab || !(hoverDevice || tab.getAttribute('aria-selected') === 'true')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      window.open(tab.href, '_blank');
    } else {
      window.location.href = tab.href;
    }
  },
  true
);
